<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1000" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>

      <v-card-text style="max-height: 70vh; overflow-y: auto">
        <div class="mb-4">
          <label class="label-input">Section</label>
          <v-row>
            <v-col cols="12" md="8">
              <v-text-field v-model="fields.title" label="Name" hide-details />
            </v-col>
            <v-col cols="12" md="4">
              <v-checkbox v-model="fields.enableAnchor" label="Enable Anchor" hide-details />
            </v-col>
          </v-row>
        </div>

        <div class="mb-4">
          <SectionSettingsContainerFuild :settings="fields.settings" :container-page="fields.containerPage" />
        </div>

        <div class="mb-4">
          <label class="label-input">Banner Image</label>
          <div class="group-item">
            <UploadImage
              @callback="handleUploadImage"
              :image="{ imageSrc: fields.cardImage.src }"
              :height="`180`"
              :typeUpload="'image'"
              @callbackDelete="handleRemoveImage"
            />
            <v-text-field v-model="fields.cardImage.alt" class="mt-4" label="Alt" hide-details />
            <div class="d-flex align-center mt-4 mb-2" style="gap: 10px">
              <label class="mb-0">Show overlay</label>
              <input type="checkbox" v-model="fields.cardImage.showOverlay" />
            </div>
            <div v-if="fields.cardImage.showOverlay">
              <v-text-field
                v-model.number="fields.cardImage.overlayOpacity"
                type="number"
                label="Overlay opacity (0.0 - 1.0)"
                min="0"
                max="1"
                step="0.1"
                hide-details
              />
            </div>
          </div>
        </div>

        <div class="mb-4">
          <div class="d-flex align-center mb-2" style="gap: 10px">
            <label class="label-input mb-0">Content</label>
            <input type="checkbox" v-model="fields.cardContent.show" />
          </div>
          <div class="group-item">
            <v-row class="mb-4">
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="fields.cardContent.maxWidth"
                  type="number"
                  label="Max width"
                  min="0"
                  suffix="px"
                  hide-details
                />
              </v-col>
              <v-col cols="12" md="6">
                <v-select
                  v-model="fields.cardContent.position"
                  :items="positionOptions"
                  label="Position"
                  hide-details
                />
              </v-col>
            </v-row>
            <ckeditor :editor="editor" v-model="fields.cardContent.content" :config="editorConfig" />
          </div>
        </div>
      </v-card-text>

      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { updateHtmlFromData } from '../common/html/update';
import SectionSettingsContainerFuild from './common/section-settings-container-fuild.vue';

export default {
  name: 'card-banner-gatorz-section-editor',
  components: {
    UploadImage,
    SectionSettingsContainerFuild,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      positionOptions: ['left', 'center', 'right'],
      fields: {
        title: 'Card Banner Gatorz Section',
        enableAnchor: false,
        settings: {
          paddingTop: true,
          paddingBottom: true,
          backgroundColor: '#FFFFFF',
          textColor: '#000000',
          overlayColor: '#000000',
          overlayOpacity: 0,
          showOverlay: false,
          backgroundImage: '',
        },
        containerPage: {
          enableStyle: false,
          background: '#FFFFFF',
        },
        cardImage: {
          src: '',
          alt: 'Image',
          showOverlay: true,
          overlayOpacity: 0.2,
        },
        cardContent: {
          show: true,
          position: 'left',
          maxWidth: 750,
          content: '<h2>Warhawk</h2><p>Your Vision, Our Mission</p>',
        },
      },
    };
  },
  mounted() {
    this.applyExtract(this.sectionEditor.sectionExtract);
  },
  watch: {
    sectionEditor: {
      handler(newVal) {
        if (newVal && newVal.sectionExtract) {
          this.applyExtract(newVal.sectionExtract);
        }
      },
      deep: true,
    },
  },
  methods: {
    applyExtract(extract) {
      if (!extract) return;
      this.fields = {
        ...this.fields,
        ...extract,
        settings: { ...this.fields.settings, ...(extract.settings || {}) },
        containerPage: { ...this.fields.containerPage, ...(extract.containerPage || {}) },
        cardImage: { ...this.fields.cardImage, ...(extract.cardImage || {}) },
        cardContent: { ...this.fields.cardContent, ...(extract.cardContent || {}) },
      };
    },
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionCardBannerGatorz(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleUploadImage(obj) {
      this.fields.cardImage.src = obj.imageSrc || '';
    },
    handleRemoveImage() {
      this.fields.cardImage.src = '';
    },
  },
};
</script>

<style scoped lang="scss">
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
